import clsx from "clsx";
import { matchSorter } from "match-sorter";
import { useState } from "react";
import { ModalContainer } from "components/modal/modal.container";
import { SearchFilterComponent } from "components/table/search-filter.component";

export function ModalBulkSelectOptions({ visible, options = [], onChange, onClose, title = "Select options title" }) {
	const [searchKeyword, setSearchKeyword] = useState("");

	return (
		<ModalContainer visible={visible}>
			<div className="rounded-2xl bg-white shadow-md p-4 w-[480px]">
				<div className="relative text-center py-4">
					<div className="font-bold text-red-50">{title}</div>

					<button
						type="button"
						className="absolute top-0 right-0 border-0"
						onClick={() => {
							onClose();
							setSearchKeyword("");
						}}>
						<span className="icon-ico-close"></span>
					</button>
				</div>
				<SearchFilterComponent
					placeholder="Search..."
					controllerInput
					value={searchKeyword}
					containerClassName="relative w-[100%] mr-2"
					onChange={e => setSearchKeyword(e.target?.value)}
				/>
				<div className="scroll content-scroll mt-3">
					{matchSorter(options, searchKeyword, { keys: ["name"] }).map(optionItem => (
						<div className="item-regional mb-3">
							<input type="checkbox" className="hidden" id="regional-1" />
							<label
								onClick={() => {
									onChange({ ...optionItem, selected: !optionItem?.selected });
								}}
								class={clsx(
									"flex justify-between items-center border border-solid border-grey-10 py-3 px-4 rounded-lg cursor-pointer",
									optionItem.selected && "border-red-50 border-solid text-red transition-all",
								)}>
								<div className="text-sm text-grey-70">{optionItem?.name}</div>
								<span
									onClick={() => {
										onChange({ ...optionItem, selected: !optionItem?.selected });
									}}
									class={clsx(
										"text-red-50",
										optionItem?.selected ? "icon-ico-circle-check" : "icon-ico-circle-plus ",
									)}></span>
							</label>
						</div>
					))}
				</div>
			</div>
		</ModalContainer>
	);
}
